import type { ServiceRun } from '../../api/monitor';
import { Panel } from '../../components/ui/Card';
import { formatCheckedAt } from '../../lib/health';
import { RUN_TONE, runDetail } from '../../lib/serviceRuns';

interface ServiceRunsCardProps {
  runs: ServiceRun[];
  onSeeAll: () => void;
}

/**
 * Última execução de cada job (`service_runs`). É uma linha por job, e não as
 * N execuções mais recentes: a checagem de saúde roda de cinco em cinco minutos
 * e esconderia os jobs diários, que são exatamente os que alguém quer conferir.
 */
export function ServiceRunsCard({ runs, onSeeAll }: ServiceRunsCardProps) {
  return (
    <Panel title="Últimas execuções" action={{ label: 'serviços', onClick: onSeeAll }}>
      {runs.length === 0 ? (
        <div className="text-ink-400 py-3 text-[12.5px]">
          Nenhum serviço executado ainda.
        </div>
      ) : (
        <div className="flex flex-col gap-2.5">
          {runs.map((run) => {
            const tone = RUN_TONE[run.status];

            return (
              <div key={run.id}>
                <div className="flex items-center gap-2 text-[13px]">
                  <span className="min-w-0 flex-1 truncate font-semibold" title={run.label}>
                    {run.label}
                  </span>
                  <span className="text-ink-400 shrink-0 text-[11.5px]">
                    {formatCheckedAt(run.startedAt)}
                  </span>
                  <span
                    className={`shrink-0 rounded-full px-2 py-0.5 text-[10.5px] font-bold ${tone.pill}`}
                  >
                    {tone.label}
                  </span>
                </div>
                <div className="text-ink-400 mt-0.5 text-[11.5px]">{runDetail(run)}</div>
                {run.error ? (
                  <div className="text-danger-600 mt-0.5 text-[11.5px] font-semibold">
                    {run.error}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </Panel>
  );
}
